        <!-- DataTemplate HJ212参数模板 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="dataTemplate">
      <div class="dataTemplate_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>HJ212参数模板</h1>
      <div class="dataTemplate_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="dataTemplate_query clearfix">
      <div class="query_list clearfix fl">
        <span class="fl">模板名称：</span>
        <div class="fl">
          <el-input
            placeholder="请输入采集点"
            v-model="tmplName"
            clearable=""
          ></el-input>
        </div>
      </div>

      <el-button type="primary" @click="queryTmplName()" icon="el-icon-search">
        查询
      </el-button>
    </div>

    <div class="dataTemplate_title">
      <el-row>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="">模板名称</div>
        </el-col>
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
          <div class="">描述</div>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <div class="">操作</div>
        </el-col>
      </el-row>
    </div>

    <div
      class="dataTemplate_list"
      v-for="(item, index) in dataTemplateList"
      :key="index"
    >
      <el-row>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="deviceParam_tab">{{ item.tmplName }}</div>
        </el-col>
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
          <div class="deviceParam_tab">{{ item.remark }}</div>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <div class="deviceParam_tab">
            <span :style="{ color: 'blue' }" @click="modifyClick(index)"
              >修改</span
            >
            &nbsp;|&nbsp;
            <span :style="{ color: 'red' }" @click="deleteClick(index)"
              >删除</span
            >
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="deviceParam_btn">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="total"
        background
      >
      </el-pagination>
    </div>

    <el-drawer
      title="HJ212模板设置"
      size="60%"
      :modal="false"
      :visible.sync="drawer"
      :modal-append-to-body="false"
    >
      <div class="drawer_box">
        <div class="drawer_query clearfix">
          <div class="query_list fl">
            <span class="fl">模板名称：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="map.tmplName"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="query_list fl">
            <span class="fl">模板描述：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="map.remark"
                clearable
              ></el-input>
            </div>
          </div>
        </div>

        <div class="drawer_query clearfix">
          <div class="query_list clearfix fl">
            <span class="fl">数据项名称：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="field"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="query_list clearfix fl">
            <span class="fl">数据项描述：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="describe"
                clearable
              ></el-input>
            </div>
          </div>
          <el-button
            class="fl"
            type="primary"
            @click="addClick()"
            icon="el-icon-plus"
            >新增</el-button
          >
          <el-button
            class="fl"
            type="primary"
            @click="saveClick()"
            icon="el-icon-folder"
            >保存</el-button
          >
        </div>

        <div class="drawer_content">
          <el-row class="drawer_title">
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">序号</el-col>
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">数据名称</el-col>
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">数据描述</el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">计量单位</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">下限值</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">上限值</el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">使用状态</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">操作</el-col>
          </el-row>

          <div v-show="dataTemplateDetail.length > 0">
            <el-row
              class="drawer_list"
              v-for="(item, index) in dataTemplateDetail"
              :key="index"
            >
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" value="" v-model="item.serialNum" />
              </el-col>
              <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <input type="text" v-model="item.dataName" />
              </el-col>
              <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <input type="text" v-model="item.dataDesc" />
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <input type="text" v-model="item.measUnit" />
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" v-model="item.minValue" />
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" v-model="item.maxValue" />
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <select v-model="item.enable">
                  <option value="0">停用</option>
                  <option value="1">启用</option>
                </select>
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <p @click="shanClick(index)">删除</p>
              </el-col>
            </el-row>
          </div>
          <div v-show="dataTemplateDetail.length == 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 内容 -->
    <iframe
      v-show="false"
      class="dataTemplate_content"
      :src="apiUrls + '?txcode=DataTemplate'"
      frameborder="0"
    >
    </iframe>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // HJ212模板设置 显示/隐藏
      drawer: false,

      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 页面嵌入路径
      apiUrls: "",

      // 模板名称
      tmplName: "",

      // 模板列表
      dataTemplateList: [],
      // 模板明细
      dataTemplateDetail: [],
      // 模板参数
      map: {},
      // 模板ID
      tmplId: "",
      // 字段
      field: "",
      // 描述
      describe: "",
      // 选中模板下标
      index: "",

      // 总模板数
      total: 0,
      // 当前页数
      page: 1,
    };
  },
  created() {
    this.apiUrls = this.apiUrl;
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取模板列表
    this.DataTemplate("");
  },
  methods: {
    // 添加参数
    addClick() {
      if (this.field.length > 0 && this.describe.length > 0) {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DataTemplate", //交易码
            option: "ADD", //交易选项
            tmplId: this.tmplId, //设备ID（必填）
            dataName: this.field, //数据名称
            dataDesc: this.describe, //数据描述
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.$notify({
                title: "添加成功",
                position: "top-left",
                type: "success",
              });
              this.modifyClick(this.index);
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      } else {
        this.$notify({
          title: "字段/描述不能为空",
          position: "top-left",
          type: "warning",
        });
      }
    },
    // 删除参数
    shanClick(index) {
      let isHas = confirm(
        "是否删除数据项" +
          this.dataTemplateDetail[index].dataName +
          "/" +
          this.dataTemplateDetail[index].dataDesc
      );

      if (isHas == true) {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DataTemplate", //交易码
            option: "DEL", //交易选项
            tmplId: this.tmplId, //设备ID（必填）
            dataId: this.dataTemplateDetail[index].dataId, //数据项ID
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.modifyClick(this.index);
              this.$notify({
                title: "删除成功",
                position: "top-left",
                type: "success",
              });
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      }
    },
    // 保存参数设置
    saveClick() {
      // let list = this.ids.split(",");
      if (this.map.tmplName.length == 0) {
        this.$notify({
          title: "模板名称不能为空",
          position: "top-left",
          type: "warning",
        });
        return;
      }

      let loginToken = localStorage.getItem("loginToken");
      let arr = {
        txcode: "DataTemplate", //交易码
        option: "SAVE", //交易选项
        tmplId: this.tmplId, //设备ID（必填）
        tmplName: this.map.tmplName,
        remark: this.map.remark,
        loginToken,
      };

      for (let j = 0; j < this.dataTemplateDetail.length; j++) {
        arr["serialNum_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].dataId;
        arr["dataName_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].dataName;
        arr["dataDesc_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].dataDesc;
        arr["measUnit_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].measUnit;
        arr["minValue_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].minValue;
        arr["maxValue_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].maxValue;
        arr["enable_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].enable;
        arr["category_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].category;
        arr["yStep_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].yStep;
        arr["yBase_" + this.dataTemplateDetail[j].dataId] =
          this.dataTemplateDetail[j].yBase;
      }

      this.$axios({
        method: "post",
        url: this.api,
        data: arr,
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            this.$notify({
              title: "保存成功",
              position: "top-left",
              type: "success",
            });

            this.DataTemplate("");
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    // 查询模板
    queryTmplName() {
      this.page = 1;
      this.DataTemplate(this.tmplName);
    },

    // 模板列表
    DataTemplate(tmplName) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: " DataTemplate ", //交易码
          option: "LIST", //交易选项
          tmplName: tmplName.length > 0 ? tmplName : "", //模板名称
          page: this.page, //当前页码
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            console.log(res);
            this.dataTemplateList = res.data.list;
            this.total = res.data.rowsCount;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    // 模板明细
    modifyClick(index) {
      this.index = index;
      this.drawer = true;

      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: " DataTemplate ", //交易码
          option: "EDIT", //交易选项
          tmplId: this.dataTemplateList[index].tmplId, //模板ID（必填）
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data._STATUS == 0) {
            this.tmplId = res.data.tmplId;
            this.map = res.data.map;
            this.dataTemplateDetail = res.data.list;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    // 删除模板
    deleteClick(index) {
      let isHas = confirm(
        "是否删除模板-" + this.dataTemplateList[index].tmplName
      );

      if (isHas == true) {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DataTemplate", //交易码
            option: "REMOVE", //交易选项
            tmplId: this.dataTemplateList[index].tmplId, //模板ID（必填）
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.DataTemplate("");
              this.$notify({
                title: "删除成功",
                position: "top-left",
                type: "success",
              });
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      }
    },

    // 选择分页
    handleCurrentChange(val) {
      this.page = val;
      // 获取模板列表
      this.DataTemplate("");
    },

    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.dataTemplate {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .dataTemplate_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .dataTemplate_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.dataTemplate_query {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .query_list {
    height: 46px;
    line-height: 40px;
    margin-right: 20px;
  }
}

.dataTemplate_title {
  width: calc(100% - 30px);
  margin: 0 15px;
  text-align: center;
  color: #fff;
  height: 40px;
  line-height: 40px;
  background-color: #545c64;
}

.dataTemplate_list {
  width: calc(100% - 30px);
  margin: 0 15px;
  text-align: center;
  &:nth-child(2n) {
    background-color: #f0faff;
  }
  &:hover {
    cursor: pointer;
    background-color: rgb(253, 246, 238);
  }
  .deviceParam_tab {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    color: #333;
    // box-sizing: border-box;
    min-height: 40px;
  }
}

.deviceParam_btn {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin: 0 20px;
    color: #666666;
  }
}

// HJ212参数设置
.drawer_box {
  padding-bottom: 100px;
  .drawer_top {
    width: 100%;
    height: 30px;
    padding: 0px 20px;
    box-sizing: border-box;
    span {
      margin-right: 80px;
    }
  }

  .drawer_query {
    width: 100%;
    padding: 0px 20px;
    box-sizing: border-box;
    margin-bottom: 6px;
    .query_list {
      height: 46px;
      line-height: 40px;
      margin-right: 20px;
    }
  }
  // 112.74.33.7
  // 7001
  .drawer_btns {
    width: 100%;
    padding: 0px 15px;
    margin-bottom: 10px;
    box-sizing: border-box;
    .el-button {
      margin-right: 20px;
    }
  }

  .drawer_content {
    width: 100%;
    .drawer_title {
      width: calc(100% - 30px);
      margin: 0 15px;
      text-align: center;
      color: #fff;
      height: 40px;
      line-height: 40px;
      background-color: #545c64;
    }
    .drawer_list {
      width: calc(100% - 30px);
      margin: 0 15px;
      height: 40px;
      // line-height: 40px;
      text-align: center;
      &:nth-child(2n-1) {
        background-color: #f0faff;
      }
      &:hover {
        cursor: pointer;
        background-color: rgb(253, 246, 238);
      }
      input {
        height: 24px;
        width: 80%;
        margin: 7px 0;
        border: 1px solid #ccc;
        text-align: center;
      }
      select {
        text-indent: 10px;
        height: 26px;
        width: 80%;
        margin: 7px 0;
        border: 1px solid #ccc;
      }
      p {
        line-height: 40px;
        text-decoration: underline;
        &:hover {
          color: red;
        }
      }
    }
  }
}

// 内容
.dataTemplate_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 65px;
  left: 20px;
}
</style>